
// ------------------------------------------------------------------------
// STATE
// ------------------------------------------------------------------------
const state = {
    activeUrl: '',
};


// ------------------------------------------------------------------------
// MUTATIONS
// ------------------------------------------------------------------------
const mutations = {
    setActiveUrl(state, activeUrl) {
        state.activeUrl = activeUrl;
    },
};


// ------------------------------------------------------------------------
// ACTIONS
// ------------------------------------------------------------------------
const actions = {

};


// ------------------------------------------------------------------------
// GETTERS
// ------------------------------------------------------------------------
const getters = {

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
